import CommonHeader from '../pages/Head'
import React from 'react'
import {Link} from "react-router-dom";
import axios from 'axios';

class NewApplication extends React.Component {	  
	constructor(props) {
		super(props);
		this.state = {Appstatus:'FTP',user:localStorage.getItem('tokens'),Resp:'',finid:'',transit:'',
						checkid:'',debitid:'',pwd:'',s1:'',a1:'',s2:'',a2:'',s3:'',a3:'',
						s4:'',apploan:'',ftppayments:[],ShortNames:[], ClientName:'',province:''};	
		this.handleClientChange=this.handleClientChange.bind(this)
		this.handleChange=this.handleChange.bind(this)
		this.handleSubmit=this.handleSubmit.bind(this)		
	}
	componentDidMount() {	
		const para={user:this.state.user}											
		axios.post(process.env.REACT_APP_API_ENV+'api/findftppayments.php')			
			.then(result => {		
				this.setState({ftppayments:result.data});
			})
		axios.post(process.env.REACT_APP_API_ENV+'api/ftpclients.php')			
			.then(result => {		
				this.setState({ShortNames:result.data});
			})
	}
	handleChange = event => {
		const {name, value} = event.target
		this.setState({[name]: value})  
		this.setState({Resp:''})
	}	
	
	handleClientChange = event => {
		const {name, value} = event.target
		this.setState({[name]: value})  
		this.setState({Resp:''})			
		this.setState({finid:this.state.ftppayments.filter(sub=>sub[0]==event.target.value).map(sub=>sub[1])[0]})
		this.setState({transit:this.state.ftppayments.filter(sub=>sub[0]==event.target.value).map(sub=>sub[2])[0]})
		this.setState({checkid:this.state.ftppayments.filter(sub=>sub[0]==event.target.value).map(sub=>sub[3])[0]})
		this.setState({debitid:this.state.ftppayments.filter(sub=>sub[0]==event.target.value).map(sub=>sub[4])[0]})
		this.setState({pwd:this.state.ftppayments.filter(sub=>sub[0]==event.target.value).map(sub=>sub[5])[0]})
		this.setState({s1:this.state.ftppayments.filter(sub=>sub[0]==event.target.value).map(sub=>sub[6])[0]})
		this.setState({a1:this.state.ftppayments.filter(sub=>sub[0]==event.target.value).map(sub=>sub[7])[0]})
		this.setState({s2:this.state.ftppayments.filter(sub=>sub[0]==event.target.value).map(sub=>sub[8])[0]})
		this.setState({a2:this.state.ftppayments.filter(sub=>sub[0]==event.target.value).map(sub=>sub[9])[0]})
		this.setState({s3:this.state.ftppayments.filter(sub=>sub[0]==event.target.value).map(sub=>sub[10])[0]})
		this.setState({a3:this.state.ftppayments.filter(sub=>sub[0]==event.target.value).map(sub=>sub[11])[0]})
		this.setState({s4:this.state.ftppayments.filter(sub=>sub[0]==event.target.value).map(sub=>sub[12])[0]})
		this.setState({apploan:this.state.ftppayments.filter(sub=>sub[0]==event.target.value).map(sub=>sub[14])[0]})
		
	}
	
	handleSubmit = event => {
		event.preventDefault()		
		const {finid,transit,checkid,debitid,pwd,s1,a1,s2,a2,s3,a3,s4,apploan} = this.state						
		const userObject = {	
			user:this.state.user,		
			manageaction: this.state.Appstatus,
			province:this.state.province,
			finid:this.state.finid,
			transit:this.state.transit,
			checkid:this.state.checkid,
			debitid:this.state.debitid,
			pwd:this.state.pwd,			
			s1:this.state.s1,
			a1:this.state.a1,
			s2:this.state.s2,
			a2:this.state.a2,
			s3:this.state.s3,
			a3:this.state.a3,
			s4:this.state.s4,
			apploan:this.state.apploan
		};
		axios.post(process.env.REACT_APP_API_ENV+'api/managementprocess.php', userObject)
			.then((res) => {
				this.setState({Resp:res.data})											
			}).catch((error) => {
				console.log(error)
			});
		
	}
	render() {		
		return(
			<div style={{textAlign:'center'}}>
				<CommonHeader titles="Update FTP Information"/>
				<form onSubmit={this.handleSubmit}>
					<label><b>Please Select Client</b></label><br/>
					<select name="ClientName" style={{width: '160px',border:'1px solid #4195fc',marginLeft:'10px'}} value={this.state.ClientName} onChange={this.handleChange}>
						<option value="">--Select Client--</option>		
						{this.state.ShortNames.map(item => (<option value={item[0]} key={item[0]}>{item[0]}</option>))}	
					</select><br/><br/>	
					{(()=>{if(this.state.ClientName !== "") {return (<div>		
						<label><b>Please Select FTP Payment</b></label><br/>
						<select name="province" style={{width: '160px',border:'1px solid #4195fc',marginLeft:'10px'}} value={this.state.province} onChange={this.handleClientChange}>
							<option value="">--Select FTP Payment--</option>		
							{this.state.ftppayments.filter(sub=>sub[13]==this.state.ClientName).map(item => (<option value={item[0]} key={item[0]}>{item[0]+'~'+item[7]+'-'+item[6]+'-'+item[10]+'-'+item[12]}</option>))}	
						</select><br/><br/>	
					</div>)}})()}
					{(()=>{if(this.state.ClientName !== "" && this.state.province !== "") {return (<div>		
						<h3>Update FTP Payment</h3>
						<h4>Note: please follow the below given format to update the information</h4><br/>					
						<label style={{width: '200px',display:'inline-block',textAlign:'right'}}><b>FIN #:</b></label>
						<input type="text" name="finid" style={{width: '150px',border:'1px solid #4195fc',marginLeft:'10px'}} maxLength="3" value={this.state.finid} onChange={this.handleChange}/>
						<label style={{width: '200px',display:'inline-block',textAlign:'right'}}><b>Branch Transit:</b></label>
						<input type="text" name="transit" style={{width: '150px',border:'1px solid #4195fc',marginLeft:'10px'}} maxLength="5" value={this.state.transit} onChange={this.handleChange}/><br/><br/>
						<label style={{width: '200px',display:'inline-block',textAlign:'right'}}><b>Check Number:</b></label>
						<input type="text" name="checkid" style={{width: '150px',border:'1px solid #4195fc',marginLeft:'10px'}} maxLength="12" value={this.state.checkid} onChange={this.handleChange}/>				
						<label style={{width: '200px',display:'inline-block',textAlign:'right'}}><b>Payment:</b></label>
						<input type="text" name="debitid" style={{width: '150px',border:'1px solid #4195fc',marginLeft:'10px'}} value={this.state.debitid} onChange={this.handleChange}/><br/><br/>
						<label style={{width: '200px',display:'inline-block',textAlign:'right'}}><b>Payment Day:</b></label>
						<input type="text" name="pwd" style={{width: '150px',border:'1px solid #4195fc',marginLeft:'10px'}} value={this.state.pwd} onChange={this.handleChange}/>				
						<label style={{width: '200px',display:'inline-block',textAlign:'right'}}><b>Client:</b></label>
						<input type="text" name="s1" style={{width: '150px',border:'1px solid #4195fc',marginLeft:'10px'}} value={this.state.s1} onChange={this.handleChange}/><br/><br/>
						<label style={{width: '200px',display:'inline-block',textAlign:'right'}}><b>Account ID:</b></label>
						<input type="text" name="a1" style={{width: '150px',border:'1px solid #4195fc',marginLeft:'10px'}} value={this.state.a1} onChange={this.handleChange}/>			
						<label style={{width: '200px',display:'inline-block',textAlign:'right'}}><b>Pay Processed ?:</b></label>					
						<select name="s2" style={{width: '160px',border:'1px solid #4195fc',marginLeft:'10px'}} value={this.state.s2} onChange={this.handleChange}>
							<option value="">--FTP Processed?--</option>		
							<option value="000">--No--</option>		
							<option value="111">--Yes--</option>		
						</select><br/><br/>
						<label style={{width: '200px',display:'inline-block',textAlign:'right'}}><b>Pay Processed Time:</b></label>
						<select name="a2" style={{width: '160px',border:'1px solid #4195fc',marginLeft:'10px'}} value={this.state.a2} onChange={this.handleChange}>
							<option value="">--Morning or Afternoon--</option>		
							<option value="0">--Not Yet--</option>		
							<option value="1">--Morning--</option>		
							<option value="2">--Afternoon--</option>		
						</select>
						<label style={{width: '200px',display:'inline-block',textAlign:'right'}}><b>Payment or Deposit:</b></label>
						<select name="s3" style={{width: '160px',border:'1px solid #4195fc',marginLeft:'10px'}} value={this.state.s3} onChange={this.handleChange}>
							<option value="">--Pay or Deposit--</option>		
							<option value="PDS">--PDS--</option>		
							<option value="PAD">--PAD--</option>
							<option value="DPAD">--Delete PAD--</option>
							<option value="DPDS">--Delete PDS--</option>
							<option value="CPAD">--Create New PAD--</option>
							<option value="CPDS">--Create New PDS--</option>
							<option value="NEW">--Create New Application--</option>
						</select><br/><br/>					
						<label style={{width: '200px',display:'inline-block',textAlign:'right'}}><b>PaySimplii Released ?:</b></label>					
						<input type="text" name="a3" style={{width: '150px',border:'1px solid #4195fc',marginLeft:'10px'}} value={this.state.a3} onChange={this.handleChange}/>				
						<label style={{width: '200px',display:'inline-block',textAlign:'right'}}><b>FTP Day:</b></label>
						<input type="text" name="s4" style={{width: '150px',border:'1px solid #4195fc',marginLeft:'10px'}} value={this.state.s4} onChange={this.handleChange}/><br/><br/>
						<label style={{width: '200px',display:'inline-block',textAlign:'right'}}><b>Approved Loan:</b></label>
						<input type="text" name="apploan" style={{width: '150px',border:'1px solid #4195fc',marginLeft:'10px'}} value={this.state.apploan} onChange={this.handleChange}/><br/><br/>						
						</div>)}})()}
					<h3>{this.state.Resp}</h3><br/><br/><br/>
					<button className="btn btn-success btn-block" style={{fontSize:'150%'}}>Submit</button><br/><br/><br/>
				</form>				
			</div>
		)
	}
}

export default NewApplication